import { Award } from 'lucide-react'
import { MANAGE_SEGMENT } from '@/components/features/certificates/certificateUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const CertificatesPage = lazyPage(() => import('@/pages/Certificates'), 'CertificatesPage')
const CertificateDetailsPage = lazyPage(() => import('@/pages/CertificateDetails'), 'CertificateDetailsPage')
const CertificatesManageRedirect = lazyPage(() => import('@/pages/CertificatesManage'), 'CertificatesManageRedirect')

export const certificatesModule: ModuleDefinition = {
  key: 'certificates',
  icon: Award,
  iconName: 'award',
  namespaces: ['certificates'],
  ready: true,
  ListPage: CertificatesPage,
  /* `/{section}/{space}/manage` (the old management view) goes to the space in "Gestão"; any other item is a certificate id. */
  renderDetail: ({ params }) =>
    params.itemId === MANAGE_SEGMENT
      ? <CertificatesManageRedirect />
      : <CertificateDetailsPage />,
  workflow: { trigger: { block: 'certificates', families: ['certificate'] } }
}
